import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import {
  apiGetSupportedPhonModelList,
  apiGetSupportedPhoneBrands,
} from "./service";

export const useGetSupportedPhoneBrands = (options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.SUPPORTED_PHONE_BRANDS],
    queryFn: () =>
      apiGetSupportedPhoneBrands({}).then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetSupportedPhoneModelList = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.SUPPORTED_PHONE_MODEL_LIST, params.brand],
    queryFn: () =>
      apiGetSupportedPhonModelList(params).then((res: any) => res.data.data),
    ...options,
  });
};
